/* @flow */

import * as onboardingSelectors from '../onboarding-selectors';
import type {NutshellState} from '../../../store';

// $FlowFixMe upgrading Flow to v0.92.1 on web
const noopFunction = () => ({});

export type JoyrideState = {|
    isDemoSilo: boolean,
    isJoyrideActive: boolean,
    activeStepIndex: ?number,
|};

/**
 * Factory function for wrapping an existing `mapStateToProps` function to add
 * joyride state.  If no argument is provided, a function returning only joyride
 * state is returned.
 *
 * @param  {function} [originalMapStateToProps=noopFunction] An existing mapStateToProps to wrap
 * @return {function}                                        A function to use as the first argument to react-redux's `connect` function
 */
export const addJoyrideState = function<S>(
    originalMapStateToProps: (NutshellState) => S = noopFunction
) {
    return function(state: NutshellState) {
        const joyrideState = {
            isJoyrideActive: onboardingSelectors.getIsAnyJoyrideActive(state),
            isDemoSilo:
                typeof NutshellFrontendSettings !== 'undefined' &&
                Boolean(NutshellFrontendSettings.isDemoSilo),
            activeStepIndex: onboardingSelectors.getActiveStepIndex(state),
        };
        const originalState = originalMapStateToProps(state);

        return {...joyrideState, ...originalState};
    };
};
